module.exports = __webpack_public_path__ + "static/img/WechatIMG7003.10a3f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/WechatIMG7003.png
// module id = KZHX
// module chunks = 4